import { useEffect } from 'react'
import { Controller, useFormContext, useWatch } from 'react-hook-form'

import { CurrencyInput, FF2, Tooltip } from 'ui/components'
import { SarEdit } from '~bank-bsa-reporting/types'

export const CurrentAmount = () => {
  const { control, setValue } = useFormContext<SarEdit>()

  const transactionsInfo = useWatch({ name: 'transactionsInfo' })
  const previousCumulativeAmount = useWatch({ name: 'previousCumulativeAmount' })

  useEffect(() => {
    let currentAmount = 0
    transactionsInfo?.forEach((bankAccount) => {
      Object.entries(bankAccount).forEach(([key, value]) => {
        if (typeof value === 'number' && value > 0 && key !== 'total' && key !== 'totalIn' && key !== 'totalOut')
          currentAmount += Number(value)
      })
    })

    setValue('suspiciousActivityInfo.currentAmount', Math.ceil(currentAmount / 100))
    setValue(
      'suspiciousActivityInfo.currentCumulativeAmount',
      Math.ceil(currentAmount + Math.ceil(previousCumulativeAmount / 100))
    )
  }, [transactionsInfo, previousCumulativeAmount, setValue])

  return (
    <Controller
      name="suspiciousActivityInfo.currentAmount"
      control={control}
      render={({ field }) => (
        <FF2
          field={field}
          input={(props) => (
            <Tooltip
              content="The amount is automatically calculated based on the Transactions Information section"
              id="current_amount"
              type="dark"
            >
              <CurrencyInput {...props} disabled />
            </Tooltip>
          )}
        />
      )}
    />
  )
}
